(() => {
  // Setarile care se modifica pentru fiecare campanie.
  const GIFT_HANDLE = 'usborne-wind-up-train-carte-pentru-copii-3-ani';
  const THRESHOLD = 31900; // 319 lei, exprimat in bani
  const DISCOUNT_CODE = 'JOYDEJOI13';
  const CART_ATTR_KEY = 'promo_joy_de_joi_13_newsletter';

  const CART_LINES_UPDATE_EVENT = 'shopify:cart:lines-update';
  const root = window.Shopify?.routes?.root || '/';

  let isRunning = false;
  let rerunRequested = false;
  let syncTimer = null;
  let giftVariantId = null;

  function getCookie(name) {
    const prefix = `${encodeURIComponent(name)}=`;
    const cookie = document.cookie
      .split(';')
      .map(item => item.trim())
      .find(item => item.startsWith(prefix));

    if (!cookie) return '';

    try {
      return decodeURIComponent(cookie.slice(prefix.length));
    } catch (_) {
      return cookie.slice(prefix.length);
    }
  }

  function hasPromoSignal() {
    const url = new URL(window.location.href);
    const hasPromoQueryParam = url.searchParams.get(CART_ATTR_KEY) === '1';
    const appliedDiscountCode = getCookie('discount_code').toUpperCase();

    return hasPromoQueryParam || appliedDiscountCode === DISCOUNT_CODE.toUpperCase();
  }

  async function getGiftVariantId() {
    if (giftVariantId) return giftVariantId;

    const res = await fetch(`${root}products/${GIFT_HANDLE}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!res.ok) {
      throw new Error(`Nu am putut lua produsul cadou ${GIFT_HANDLE}`);
    }

    const product = await res.json();
    const variant = product.variants.find(item => item.available);

    if (!variant?.id) {
      throw new Error(`Produsul cadou ${GIFT_HANDLE} nu are o varianta disponibila`);
    }

    giftVariantId = variant.id;
    return giftVariantId;
  }

  async function getCart() {
    const res = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });

    if (!res.ok) {
      throw new Error('Nu am putut citi cosul');
    }

    return await res.json();
  }

  async function setPromoCartAttribute() {
    const res = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          [CART_ATTR_KEY]: '1'
        }
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Nu am putut activa promotia: ${res.status} ${text}`);
    }

    return await res.json();
  }

  function isPromoActive(cart) {
    return String(cart.attributes?.[CART_ATTR_KEY] || '') === '1';
  }

  function isAutoGift(item) {
    return String(item.properties?._auto_gift || '') === 'true';
  }

  function isCurrentAutoGift(item, currentGiftVariantId) {
    return (
      isAutoGift(item) &&
      item.variant_id === currentGiftVariantId &&
      String(item.properties?._campaign || '') === CART_ATTR_KEY
    );
  }

  function subtotalWithoutAutoGifts(cart) {
    return cart.items.reduce((sum, item) => {
      if (isAutoGift(item)) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  async function addGift(currentGiftVariantId) {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: currentGiftVariantId,
            quantity: 1,
            properties: {
              _auto_gift: 'true',
              _campaign: CART_ATTR_KEY
            }
          }
        ]
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Adaugarea cadoului a esuat: ${res.status} ${text}`);
    }

    return await getCart();
  }

  async function removeGiftItems(items) {
    const updates = {};

    for (const item of items) {
      if (item.key) updates[item.key] = 0;
    }

    if (Object.keys(updates).length === 0) return await getCart();

    const res = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Stergerea cadoului a esuat: ${res.status} ${text}`);
    }

    return await res.json();
  }

  async function setGiftQuantity(item, quantity) {
    const res = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: item.key,
        quantity
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(`Actualizarea cadoului a esuat: ${res.status} ${text}`);
    }

    return await res.json();
  }

  function dispatchCartUpdate(cart) {
    const normalizedCart = {
      ...cart,
      totalQuantity: cart.item_count
    };
    const detail = {
      items: cart.items,
      itemCount: cart.item_count,
      source: 'free-gift',
      didError: false
    };
    const event = new CustomEvent(CART_LINES_UPDATE_EVENT, { bubbles: true });

    event.action = 'update';
    event.context = 'free-gift';
    event.freeGiftUpdate = true;
    event.promise = Promise.resolve({ cart: normalizedCart, detail });

    document.dispatchEvent(event);
  }

  function scheduleSync(delay = 0) {
    if (syncTimer) window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(() => {
      syncTimer = null;
      syncGift();
    }, delay);
  }

  async function syncGift() {
    if (isRunning) {
      rerunRequested = true;
      return;
    }

    isRunning = true;
    let cartChanged = false;

    try {
      // Shopify poate elimina parametrul din redirect cand adauga UTM-urile
      // Shopify Email. Cookie-ul discount_code ramane si activeaza aceeasi campanie.
      let cart = hasPromoSignal() ? await setPromoCartAttribute() : await getCart();
      const autoGifts = cart.items.filter(isAutoGift);

      // Un cadou dintr-o campanie veche nu trebuie sa ramana in cos.
      if (!isPromoActive(cart)) {
        if (autoGifts.length > 0) {
          cart = await removeGiftItems(autoGifts);
          dispatchCartUpdate(cart);
        }
        return;
      }

      const currentGiftVariantId = await getGiftVariantId();
      const staleGifts = autoGifts.filter(item => !isCurrentAutoGift(item, currentGiftVariantId));

      if (staleGifts.length > 0) {
        cart = await removeGiftItems(staleGifts);
        cartChanged = true;
      }

      let currentGift = cart.items.find(item => isCurrentAutoGift(item, currentGiftVariantId));
      const subtotal = subtotalWithoutAutoGifts(cart);

      if (currentGift?.quantity > 1) {
        cart = await setGiftQuantity(currentGift, 1);
        cartChanged = true;
        currentGift = cart.items.find(item => isCurrentAutoGift(item, currentGiftVariantId));
      }

      if (subtotal >= THRESHOLD && !currentGift) {
        cart = await addGift(currentGiftVariantId);
        cartChanged = true;
      } else if (subtotal < THRESHOLD && currentGift) {
        cart = await removeGiftItems([currentGift]);
        cartChanged = true;
      }

      if (cartChanged) dispatchCartUpdate(cart);
    } catch (err) {
      console.error('FREE GIFT ERROR:', err);
    } finally {
      isRunning = false;

      if (rerunRequested) {
        rerunRequested = false;
        scheduleSync(0);
      }
    }
  }

  function bindTriggers() {
    scheduleSync(0);

    // Horizon 4.1.4 rezolva promise-ul numai dupa ce operatia reala din cos s-a terminat.
    document.addEventListener(CART_LINES_UPDATE_EVENT, event => {
      if (event.freeGiftUpdate) return;

      if (event.promise && typeof event.promise.then === 'function') {
        event.promise.then(
          () => scheduleSync(0),
          () => scheduleSync(300)
        );
      } else {
        scheduleSync(300);
      }
    });

    // Compatibilitate cu aplicatii care inca emit evenimentul vechi.
    document.addEventListener('cart:updated', () => scheduleSync(100));

    window.addEventListener('focus', () => scheduleSync(100));
    window.addEventListener('pageshow', () => scheduleSync(100));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindTriggers, { once: true });
  } else {
    bindTriggers();
  }
})();
